<template>
  <donut-chart-card
    title="안전보건 예산 현황"
    :value="data"
    unit="천원"
    :isMoveWrite="isMoveWrite"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/chart/DonutChartCard.vue'
import CircleGraphUtil from '@/util/CircleGraphUtil'
export default {
  name: 'DonutChart05',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    }
  },
  watch: {
    dataType (value) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 5,
      boardIds: [106, 154, 155], //106, 154, 155
      summaryKey: this.dataType === 'field' ? ['안전보건예산_사업장명', 'sum'] : ['안전보건예산_항목명', 'sum'],
      data: [{label: 'label', value: 0}],
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      const summaryKey = this.summaryKey
      const data1 = await this.loadGraphPiece(this.boardIds[0], summaryKey)
      const data2 = await this.loadGraphPiece(this.boardIds[1], summaryKey)
      const data3 = await this.loadGraphPiece(this.boardIds[2], summaryKey)

      let value = data1
      value = CircleGraphUtil.combineCircleGraphData(value, data2)
      value = CircleGraphUtil.combineCircleGraphData(value, data3)

      this.data = CircleGraphUtil.circleModuleWithData(value)
    },
    async loadGraphPiece (boardId, summaryKey) {
      const value = await this.$store.dispatch('summary/FIRA_LOAD_SUMMARY', {
        boardId,
        projectIds: this.projectId ? [this.projectId] : []
      }).then(value => {

        if (this.dataType === 'project') {
          return CircleGraphUtil.getProjectFromEachProject(value, summaryKey)
        } else if (this.dataType === 'company') {
          return CircleGraphUtil.getCompanyFromEachCompany(value, summaryKey)
        } else {
          return CircleGraphUtil.getColumnFromEachCompany(value, summaryKey)
        }
      })
      return value
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardIds[0]}`
      this.$router.push({name: 'write|tab', params: {pageType: 'write', proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
